import React from "react";
import PageShell from "@/components/site/PageShell";
import PageHeader from "@/components/site/PageHeader";
import ContactForm from "@/components/site/ContactForm";
import { Container, Eyebrow, Reveal } from "@/components/site/ui";
import { COOPERACAO, RTL, IMG } from "@/content/site";

const ContatoPage = () => (
    <PageShell path="/contato" title="Contato" sections={["header", "formulario"]}>
        <PageHeader testId="contato-page-header" eyebrow={COOPERACAO.eyebrow} title={COOPERACAO.title} lead={COOPERACAO.lead} img={IMG.contato} alt="Mesa de trabalho com notebook, caderno e canetas" />
        <section data-section-id="formulario" className="pb-28 pt-6">
            <Container className="grid grid-cols-1 lg:grid-cols-12 gap-14">
                <Reveal className="lg:col-span-4 flex flex-col gap-10">
                    <ul className="flex flex-col">
                        {COOPERACAO.temas.map((t) => (
                            <li key={t} className="py-4 border-t border-[#1B3025] font-sans font-light text-[14px] text-[#D7D1BF]">{t}</li>
                        ))}
                    </ul>
                    <div>
                        <Eyebrow>E-mail</Eyebrow>
                        <a href={`mailto:${COOPERACAO.email}`} data-testid="contato-email" className="font-sans font-light text-[14px] text-[#B0B6A6] hover:text-[#F2EFE5] transition-colors">
                            {COOPERACAO.email}
                        </a>
                    </div>
                    <div>
                        <p className="font-sans font-light text-[12.5px] leading-[1.7] text-[#7E8978]">{COOPERACAO.comercial}</p>
                        <a href={RTL.url} target="_blank" rel="noopener noreferrer" data-testid="contato-rtl-link" className="mt-2 inline-block font-sans text-[12.5px] text-[#C7A659] hover:text-[#e2c886]">
                            {RTL.label} ↗
                        </a>
                    </div>
                </Reveal>
                <Reveal className="lg:col-span-8" delay={120}>
                    <ContactForm source="contato" />
                </Reveal>
            </Container>
        </section>
    </PageShell>
);

export default ContatoPage;
